import {
  DELETE_EXCLUSION_FAILED,
  DELETE_EXCLUSION_STARTED,
  DELETE_EXCLUSION_SUCCESS,
  UPDATE_CURRENT_HOTEL,
  UPDATE_HOTEL_DATA,
  UPDATE_SERVICE_STARTED,
  UPDATE_SERVICE_SUCCESS
} from '../actions/actionTypes'

export default function hotelDetails(
  state = {
    isLoading: true,
    subsidiary: [],
    chainExclusions: [],
    locationExclusions: [],
    subscriptions: [],
    rateCodeUsages: [],
    trackingInfoUsages: [],
    otherSubsidiaries: {},
    deletedExclusion: null,
    pms: null
  },
  action
) {
  switch (action.type) {
    case 'GET_OTHER_HOTEL_DETAILS_STARTED':
      return {
        ...state,
        isLoading: true,
        deletedExclusion: null
      }

    case 'GOT_OTHER_HOTEL_DETAILS':
      return {
        ...state,
        otherSubsidiaries: {
          ...state.otherSubsidiaries,
          [action.payload.id]: action.payload.details
        },
        isLoading: false
      }

    case 'GET_OTHER_HOTEL_DETAILS_FAILED':
      return {
        ...state,
        isLoading: false
      }

    case 'GET_HOTEL_DETAILS_STARTED':
      return {
        ...state,
        isLoading: true,
        deletedExclusion: null
      }

    case 'GOT_HOTEL_DETAILS':
      return {
        ...state,
        ...action.payload,
        isLoading: false
      }

    case 'GOT_CAMPAIGNS':
      return {
        ...state
      }

    case 'SET_HOTEL_LOCALE':
      return {
        ...state,
        locale: action.payload.locale,
        currency: action.payload.currency
      }

    case 'SAVE_POSTED_SUBSIDIARY': {
      const {
        displayId,
        primaryWebsiteUrl,
        locale,
        currency,
        currentUtcOffset,
        currentGroupName,
        currentGroupId,
        ianaTimeZoneId,
        currentHotel: name,
        billingAddress,
        parentChainCode,
        subsidiaryShortLinkToken,
        subsidiaryPMS,
        isGdsBookingAvailable,
        isIndependentlyManaged,
        inviteBackIsDisabled,
        bookingEngine,
        bookingEngineSlug,
        externalHotelId,
        cultureCode,
        status,
        hasMissingCampaignRegisterData,
        isPreOnboardingCompleted,
        isSetupCompleted,
        csmEmail
      } = action.payload

      return {
        ...state,
        name,
        locale,
        primaryWebsiteUrl,
        currency,
        currentUtcOffset,
        cultureCode,
        groupName: currentGroupName,
        groupId: currentGroupId,
        ianaTimeZoneId,
        billingAddress,
        parentChainCode,
        subsidiaryShortLinkToken,
        displayId,
        isGdsBookingAvailable,
        isIndependentlyManaged,
        inviteBackIsDisabled,
        pms: subsidiaryPMS,
        bookingEngine,
        bookingEngineSlug,
        externalHotelId,
        status,
        hasMissingCampaignRegisterData,
        isPreOnboardingCompleted,
        isSetupCompleted,
        csmEmail
      }
    }

    case 'GET_HOTEL_DETAILS_FAILED':
      return {
        ...state,
        isLoading: false
      }

    case UPDATE_SERVICE_STARTED:
      return {
        ...state,
        isLoading: true
      }

    case UPDATE_SERVICE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        subscriptions: action.payload
      }

    case DELETE_EXCLUSION_STARTED:
      return {
        ...state,
        isLoading: true
      }

    case DELETE_EXCLUSION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        chainExclusions: state.chainExclusions.filter(
          e => e.exclusionId !== action.payload.exclusionId
        ),
        locationExclusions: state.locationExclusions.filter(
          e => e.exclusionId !== action.payload.exclusionId
        ),
        deletedExclusion: action.payload
      }

    case DELETE_EXCLUSION_FAILED:
      return {
        ...state,
        isLoading: false
      }

    case UPDATE_CURRENT_HOTEL: {
      const {
        displayId,
        primaryWebsiteUrl,
        locale,
        currency,
        currentUtcOffset,
        currentGroupName,
        currentGroupId,
        ianaTimeZoneId,
        currentHotel: name,
        billingAddress,
        parentChainCode,
        subsidiaryShortLinkToken,
        subsidiaryPMS,
        isGdsBookingAvailable,
        isIndependentlyManaged,
        inviteBackIsDisabled,
        bookingEngine,
        bookingEngineSlug,
        externalHotelId,
        cultureCode,
        status
      } = action.payload

      return {
        ...state,
        displayId,
        primaryWebsiteUrl,
        locale,
        currency,
        currentUtcOffset,
        currentGroupName,
        currentGroupId,
        ianaTimeZoneId,
        currentHotel: name,
        billingAddress,
        parentChainCode,
        subsidiaryShortLinkToken,
        subsidiaryPMS,
        isGdsBookingAvailable,
        isIndependentlyManaged,
        inviteBackIsDisabled,
        bookingEngine,
        bookingEngineSlug,
        externalHotelId,
        cultureCode,
        status
      }
    }

    case UPDATE_HOTEL_DATA:
      return {
        ...state,
        otherSubsidiaries: {
          ...state.otherSubsidiaries,
          [action.payload.id]: {
            ...state.otherSubsidiaries[action.payload.id],
            ...action.payload.data
          }
        },
        isLoading: false
      }

    default:
      return state
  }
}
